import { AlertDialogBody, AlertDialogFooter, Button, ButtonGroup, useDisclosure } from "@chakra-ui/react"
import { Dialog } from "components"
import { Authenticate } from "screens"

export default function Confirmation({ handleSubmit, ...props }){
  const authenticate = useDisclosure()

  return (
    <>
      <Dialog isCentered={true} title="Fazer Pedido de Venda Direta" closeOnOverlayClick={true} {...props}>
        <AlertDialogBody fontSize="small">
          Você tem certeza que deseja criar essa venda direta? Confira os dados antes de enviar o pedido.
        </AlertDialogBody>
        <AlertDialogFooter>
          <ButtonGroup size="sm">
            <Button
              variant="ghost"
              onClick={authenticate.onOpen}
            >Confirmar Envio</Button>
            <Button
              variant="ghost"
              colorScheme="red"
              onClick={props.onClose}
            >Fechar</Button>
          </ButtonGroup>
        </AlertDialogFooter>
      </Dialog>
      <Authenticate {...authenticate} onSuccess={handleSubmit}/>
    </>
  )
}
